const webAddresses = {
  testbaseDiscount: {
    href: "https://www.testbase.co.uk/",
    name: "testbase.co.uk"
  },
  examproDiscount: {
    href: "https://www.exampro.co.uk/",
    name: "exampro.co.uk"
  },
  termsAndConditions: {
    href: "https://www.doublestruck.co.uk/terms-and-conditions/",
    name: "terms and conditions"
  },
  privacyStatement: {
    href: "https://www.doublestruck.co.uk/privacy-statement/",
    name: "privacy statement"
  },
  cookiePolicy: {
    href: "https://www.doublestruck.co.uk/cookie-policy/",
    name: "cookie policy"
  }
};

const telephoneNumbers = {
  modifiedTests: "0345 145 1500"
};

export { webAddresses, telephoneNumbers };
